

export default {
  props: {
    value: {
      type: [Number, String],
    },
    allowBlank: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    autocomplete: {
      type: Boolean,
      default: true,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    currencySymbol: {
      type: String,
      default: '£',
    },
    currencyDenomination: {
      type: Number,
      default: 100,
    },
  },

  created: function() {
  },

  data: function() {
    return {
      isInputActive: false,
    };
  },
  computed: {

    inputVal: {

      get: function() {

        if (this.isInputActive) {
          if ((this.value === '' || this.value === null) && this.allowBlank)
            return '';
          // Cursor is inside the input field. unformat display value for user
          return (this.value / this.currencyDenomination).toString();
        } else {
          if (this.value === '' || this.value == null)
            return '';
          // User is not modifying now. Format display value for user interface
          return this.currencySymbol +
              (this.value / this.currencyDenomination).toFixed(2).
                  replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
        }
      },
      set: function(modifiedValue) {

        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''));
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          if (this.allowBlank)
            newValue = '';
          else
            newValue = 0;
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        if (newValue !== '')
          newValue = Math.round(newValue * this.currencyDenomination);

        this.$emit('input', newValue);
        this.$emit('redemption-updated')

      },

    },
  },
  methods: {

    /*
    * Concat message for count characters
    * @return string
    */
    messageLength(count, maxLenght) {
      let mcount = count ? count.length : 0;
      return mcount + ' / ' + maxLenght;
    },

    onFocus() {
      this.$emit('onFocus');
    },

    onBlur() {
      this.$emit('onBlur');
    },
  },
};

